export default class MediaManager {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      accountId: null,
      isMaster: null,
      login: '',
      mmServiceUserId: null,
      token: '',
      url: ''
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      accountId: this.accountId,
      isMaster: this.isMaster,
      login: this.login,
      mmServiceUserId: this.mmServiceUserId,
      token: this.token,
      url: this.url
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mediaManager/model.js